import { useAppState } from 'hooks/useAppState';

export const useSignedOut = () => {
  const { authType } = useAppState();

  return authType === 'NONE';
};
